'use client';

import { __resetStyles, mergeClasses } from '@griffel/react';
export const toastFooterClassNames = {
  root: 'fui-ToastFooter'
};
/**
 * Styles for the root slot
 */
const useRootBaseClassName = /*#__PURE__*/__resetStyles("r56x6h2", null, [".r56x6h2{padding-top:16px;grid-column-start:2;grid-column-end:3;display:flex;align-items:center;gap:14px;}"]);
/**
 * Apply styling to the ToastFooter slots based on the state
 */
export const useToastFooterStyles_unstable = state => {
  'use no memo';

  const rootBaseClassName = useRootBaseClassName();
  state.root.className = mergeClasses(toastFooterClassNames.root, rootBaseClassName, state.root.className);
  return state;
};